import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { LayoutComponent } from './layout.component';
import { RouterModule } from '@angular/router';
import { ComponentModule } from '../_component/component.module';
import { RespComponentModule } from '../../resp/_component/respComponent.module';
@NgModule({
  declarations: [LayoutComponent],
  imports: [CommonModule, ComponentModule, RespComponentModule, RouterModule, SharedModule],
  // entryComponents: [LayoutComponent],
  exports: [LayoutComponent],
})
export class LayoutModule {}
